import axios from "axios";
import { toast } from "sonner";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = sessionStorage.getItem("cr_token") || localStorage.getItem("cr_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

// Surface View-as read-only 403s with a clear toast + block propagation when the UI
// can't cleanly recover. Anything else (401, 400, 500) bubbles up untouched.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 403 && typeof d === "string" && d.startsWith("View-as mode")) {
      toast.error(d);
    }
    return Promise.reject(err);
  }
);

export const SUPPORTED_CCY = ["USD"];

export const formatUSD = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

// Alias kept for any lingering imports.
export const formatVND = formatUSD;

export const formatCcy = (n, ccy = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: ccy || "USD", maximumFractionDigits: 2 }).format(n || 0);
